import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../component/CurrencyCell";
import { monthNames } from "../../../../component/constent";
const columns = [
  { field: "Month-Year", label: "Month-Year" },
  { field: "Total Labour", label: "Total Labour" },

  { field: "Total Store", label: "Total Store" },
  { field: "Freight", label: "Freight" },
  { field: "Proforma O/C", label: "Proforma O/C" },
  { field: "Revenue Total", label: "Revenue Total" },
  { field: "POH", label: "POH" },
  { field: "DRR", label: "DRR" },
  { field: "Return Store", label: "Return Store" },
  { field: "Elect", label: "Elect" },
  { field: "Bulk Order", label: "Bulk Order" },




];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {

const getMonthName = (month) => {
  const monthNumber = Number(month);
  return monthNames[monthNumber ] || "";
};

  const bulkOrder = parseAmount(totals.BulkOrder);

  const adjustedRevenue =
    parseAmount(totals.revenue) - bulkOrder;

  const adjustedPOH =
    parseAmount(totals.POH) + bulkOrder;

    
  return (
    <TableContainer>
      <Table
        size="small"
       stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {

            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                <TableCell colSpan={1} align="right">{getMonthName(row.PMONTH)} - {row.PYEAR}</TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.Labour} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.store} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.freight} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.proforma} />
                </TableCell>
                <TableCell align="right">
                  <CurrencyCell value={row.revenue} />
                </TableCell>
                <TableCell align="right">
                  <CurrencyCell value={row.POH} />
                </TableCell>
                <TableCell align="right">
                  <CurrencyCell value={row.DRR} />
                </TableCell>
                <TableCell align="right">
                  <CurrencyCell value={row.ReturnStore} />
                </TableCell>
                <TableCell align="right">
                  <CurrencyCell value={row.Electrical} />
                </TableCell>
                <TableCell align="right">
                  <CurrencyCell value={row.BulkOrder} />
                </TableCell>



              </TableRow>
            );
          })}

         {showTotal && (
  <>
    {/* ================= ORIGINAL TOTAL ================= */}
    <TableRow
      sx={{
        bgcolor: "primary.light",
        "& td": {
          fontWeight: 700,
          borderTop: "2px solid",
          borderColor: "primary.main",
        },
      }}
    >
      <TableCell colSpan={1} align="right">
        Total Amount
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.Labour} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.store} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.freight} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.proforma} />
      </TableCell>

      {/* ORIGINAL REVENUE */}
      <TableCell align="right">
        <CurrencyCell value={totals.revenue} />
      </TableCell>

      {/* ORIGINAL POH */}
      <TableCell align="right">
        <CurrencyCell value={totals.POH} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.DRR} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.ReturnStore} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.Electrical} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.BulkOrder} />
      </TableCell>
    </TableRow>


    {/* ================= BULK ORDER ADJUSTMENT ================= */}
    <TableRow
      sx={{
        "& td": {
          fontWeight: 600,
          borderBottom: "none",
        },
      }}
    >
      <TableCell colSpan={5} align="right">
        Bulk Order Adjustment
      </TableCell>

      {/* Revenue - Bulk Order */}
      <TableCell
        align="right"
        sx={{ color: "error.main" }}
      >
        -<CurrencyCell value={totals.BulkOrder} />
      </TableCell>

      {/* POH + Bulk Order */}
      <TableCell
        align="right"
        sx={{ color: "success.main" }}
      >
        +<CurrencyCell value={totals.BulkOrder} />
      </TableCell>

      {/* Other columns blank */}
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
    </TableRow>


    {/* ================= NEW TOTAL ================= */}
    <TableRow
      sx={{
        bgcolor: "success.light",
        "& td": {
          fontWeight: 700,
          borderTop: "2px solid",
          borderColor: "success.main",
        },
      }}
    >
      <TableCell colSpan={1} align="right">
        New Total Amount
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.Labour} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.store} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.freight} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.proforma} />
      </TableCell>

      {/* Revenue - Bulk Order */}
      <TableCell align="right">
        <CurrencyCell
          value={
            parseAmount(totals.revenue) -
            parseAmount(totals.BulkOrder)
          }
        />
      </TableCell>

      {/* POH + Bulk Order */}
      <TableCell align="right">
        <CurrencyCell
          value={
            parseAmount(totals.POH) +
            parseAmount(totals.BulkOrder)
          }
        />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.DRR} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.ReturnStore} />
      </TableCell>

      <TableCell align="right">
        <CurrencyCell value={totals.Electrical} />
      </TableCell>

      {/* Bulk Order itself remains unchanged */}
      <TableCell align="right">
        <CurrencyCell value={totals.BulkOrder} />
      </TableCell>
    </TableRow>
  </>
)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}